
var
    symbols = require('../utils/symbols'),
    DraughtBoard = require('./DraughtBoard'),
    Arbiter = require('../brain/Arbiter'),
    PDNParser =  require('./../PDNParser'),
    Color = symbols.Color,
    Piece = symbols.Piece,
    DraughtsTypes = symbols.DraughtsTypes8x8
;

function Game(boardSize, draughtType=DraughtsTypes.NONE) {
    if (boardSize === 64) {
        this.board = new DraughtBoard(8, draughtType);
    } else if (boardSize === 144) {
        this.board = new DraughtBoard(12);
    } else if (boardSize === 100) {
        this.board = new DraughtBoard(10);
    } else {
        this.board = new DraughtBoard(boardSize);
    }
    this.isChessNotation = draughtType === DraughtsTypes.BRAZILIAN || draughtType === DraughtsTypes.RUSSIAN;
    this.moves = []; // [Move]
    this.index = -1;
}


Game.prototype.parsePDN = function(pdn) {
    
    let parserMap = {
        a1:29, c1:30, e1:31, g1:32,
        b2:25, d2:26, f2:27, h2:28,
        a3:21, c3:22, e3:23, g3:24,
        b4:17, d4:18, f4:19, h4:20,
        a5:13, c5:14, e5:15, g5:16,
        b6:9, d6:10, f6:11, h6:12,
        a7:5, c7:6, e7:7, g7:8,
        b8:1, d8:2, f8:3, h8:4
    };
    this.board.setInitialPosition();
    this.start();
    let data = [];
    if (this.board.getBoardSize() === 8) {
        let checkMovesRX = /][\\r\\n\s]*(\d+.[\sa-hA-H0-9x\-.\\r\\n/]*)/g;
        const checkMoves = checkMovesRX.exec(pdn);
        if (checkMoves != null) {
            let moves = checkMoves[1];
            for(let name in parserMap) {
                moves = moves.replace(new RegExp(name, 'g'), parserMap[name]);
            }
            pdn = pdn.replace(checkMovesRX, '');
            pdn += ']\n\n' + moves;
        }
        let checkFenRX = /\[FEN +(.+)]/g;
        const checkFen = checkFenRX.exec(pdn);
        if (checkFen != null) {
            let orgFen = checkFen[1];
            let fen = checkFen[1];
            fen = fen.replace(".", "");
            for(let name in parserMap) {
                fen = fen.replace(new RegExp(name, 'g'), parserMap[name]);
            }
            pdn = pdn.replace(orgFen, fen);
        }
    }

    if (Array.isArray(pdn)) {
        data = pdn.join('\n');
    } else {
        data = pdn;
    }


    let parser = new PDNParser(data);
    let parserObject = parser.parse(1);
    if (parserObject.fenTurnColor === "W" || parserObject.fenTurnColor === "B") {
        let board = this.getBoard();
        let squareMax = board.squareMaxNum();
        for (let i = 1; i<=squareMax; i++) {
            board.setPiece(Piece.EMPTY, i);
        }
        board.setPosition(Piece.PAWN_WHITE, parserObject.fenWhitePawn);
        board.setPosition(Piece.DAME_WHITE, parserObject.fenWhiteKing);
        board.setPosition(Piece.PAWN_BLACK, parserObject.fenBlackPawn);
        board.setPosition(Piece.DAME_BLACK, parserObject.fenBlackKing);
    }
    for (let i = 0; i < parserObject.listMoveText.length; i++) {
        const comment1 = parserObject.listMoveText[i].comment1;
        const comment2 = parserObject.listMoveText[i].comment2;
        const move1 = parserObject.listMoveText[i].move1;
        const move2 = parserObject.listMoveText[i].move2;
        this.addMoveTxt(move1, comment1);
        this.addMoveTxt(move2, comment2);
    }
    if (parserObject.fen) {
        this.fen = parserObject.fen;
    }
    this.start();
}



Game.prototype.getMoves = function() {
    return this.moves;
}

Game.prototype.removeRestMoves = function() {
    const currentIdx = this.index;
    while ( this.moves.length > (currentIdx + 1) ) {
        this.moves.pop();
    }
}

Game.prototype.isEmpty = function(square) {
    return square > 0 ? this.board.getPiece(square) === Piece.EMPTY : true;
}

Game.prototype.getValidMovesGetSourceFields = function(dstNum) {

    let result = {
        selectedSquare: dstNum,
        validMoves: [],
        isDestinationSquare: true,
        isValid: false,
        hasError: this._hasError()
    }

    if (dstNum <= 0 || dstNum > this.board.squareMaxNum()) {
        return result;
    }
    const lastColor = this._getLastMoveColor();

    for (let startNum = 1; startNum<=this.board.squareMaxNum(); startNum++) {
        if (dstNum != startNum) {
            if (this.board.isSquareEmpty(startNum)) {
                continue;
            }
            if (this.board.getPiece(startNum).color === lastColor) {
                continue;
            }
        }
        if (this._isValidMove(startNum, dstNum)) {
            result.validMoves.push(startNum);
        }
    }
    return result;
}

Game.prototype.getEmptySelectedSquare = function() {
    return ({
        selectedSquare: 0,
        validMoves: [],
        isDestinationSquare: false,
        isValid: false,
        hasError: false
    })
}

Game.prototype.getValidMoves = function(startNum) {
    let result = {
        selectedSquare: startNum,
        validMoves: [],
        isDestinationSquare: false,
        isValid: false,
        hasError: this._hasError()
    }

    if (startNum <= 0 || startNum > this.board.squareMaxNum() || this.board.isSquareEmpty(startNum)) {
        return result;
    }
    
    if (this.board.getPiece(startNum).color === this._getLastMoveColor()) {
        return result;
    }

    for (let dstNum = 1; dstNum<=this.board.squareMaxNum(); dstNum++) {
        if (this._isValidMove(startNum, dstNum)) {
            result.validMoves.push(dstNum);
            result.isValid = true;
        }
    }
    return result;
}

Game.prototype.getMovesSize = function() {
    return this.moves.length;
}

Game.prototype._getLastMoveColor = function() {
    let result = Color.NONE;
    const iLast = this.index;
    if (iLast > -1 && iLast < this.moves.length){
        result = this.moves[iLast].color;
    }
    return result;
}

Game.prototype._isValidMove = function(startNum, endNum) {
    let result = false;
    let middleSquaresNum = null;

    if (!this._hasError()) {
        // Remember previous color played.
        const iLast = this.index;
        let previousColorPlayed = null;
        if (iLast > -1){
            previousColorPlayed = this.moves[iLast].color;
        }

        const m = Arbiter.getMove(this.board, startNum, endNum, middleSquaresNum, previousColorPlayed, this.draughtsType8x8);
        result = m.status === true;
        
    } else {
        console.log("vaildMove(" + startNum + ", " + endNum + ") : ERROR");
    }
    return result;
};

Game.prototype.getBoard = function() {
    return this.board;
}

Game.prototype.hasMove = function() {
    return (this.moves.length > 0);
};

/**
 * Définition des mouvements
 *
 * @param startNum
 *            Numéro de la case de départ (REQUIS)
 * @param endNum
 *            Numéro de la case d'arrivée (REQUIS)
 * @param middleSquaresNum
 *            Liste des cases intermédiaires (Facultatif)
 */
Game.prototype.addMove = function(startNum, endNum, middleSquaresNum, comment) {
    let result = null;
    middleSquaresNum = middleSquaresNum ? middleSquaresNum : null;

    if (!this._hasError()) {

        // Positionner le damier
        this.end();

        // Remember previous color played.
        let iLast = this._getLastIndex();
        let previousColorPlayed = null;
        if (iLast > -1){
            previousColorPlayed = this.moves[iLast].color;
        }

        let m = Arbiter.getMove(this.board, startNum, endNum, middleSquaresNum, previousColorPlayed, this.draughtsType8x8);
        m.commment = comment;
        result = m;
        this.moves.push(m);
    } else {
        //console.log("addMove(" + startNum + ", " + endNum + ") : ERROR");
    }
    return result;
};

/**
 * Exemples : <br />
 * Prise : 24x22 ou 24x33x22 ou 24x13x...x22 <br />
 * Déplacement : 24-29
 * */
Game.prototype.addMoveTxt = function(move, comment) {
    let result = null;
    if (move != null) {

        move = move.toLowerCase();
        move = move.replace(" ", "");

        let sep = "";
        if (move.indexOf("-") > -1) {
            sep = "-";
        } else if (move.indexOf("x") > -1) {
            sep = "x";
        }

        if (sep !== "") {
            let list = move.split(sep);
            let nb = list.length;
            if (nb > 1) {
                let error = false;
                let iStart = parseInt(list[0], 10);
                let iEnd = parseInt(list[nb - 1], 10);
                let iInters = [];

                if (iStart === null || iEnd === null) {
                    error = true;
                } else {
                    if (nb > 2) {
                        for (let i = 1; i <= nb - 2; i++) {
                            let inter = parseInt(list[i], 10);
                            if (inter != null) {
                                iInters.push(inter);
                            } else {
                                error = true;
                            }
                        }
                    }
                }
                if (!error) {
                    result = this.addMove(iStart, iEnd, iInters, comment);
                } else {
                    console.log("addMove: ERROR (4) " + move);
                }

            } else {
                console.log("addMove: ERROR (3) " + move);
            }
        } else {
            console.log("addMove: ERROR (2) ", move);
        }

    } else {
        console.log("addMove: ERROR (1) ", move);
    }
    return result;
};

Game.prototype._getStatusNextIndex = function() {
    let status = true;
    if (this.index < this._getLastIndex()) {
        let m = this.moves[this.index + 1];
        status = m.status;
    }
    return status;
};

Game.prototype.getCurrentPosition = function() {
        
    const squares = this.board.getSquares();
    let positionData = {
        position: [],
        move: null
    }
    for (let i = 0; i < squares.length; i++) {
        const square = squares[i];
        positionData.position[square.number] = square.piece;
    }
    
    if (this.hasMove()) {
        const move = this.getCurrentMove();
        if (move) {

            const time = (move.commment) ? this.parseTime(move.commment) : null;
            positionData.move = {
                src: move.startingSquareNum,
                dst: move.endingSquareNum,
                captured: [],
                landing: move.landingSquaresNum.slice(),
                message: move.message,
                color: move.color,
                clockWhite: time ? time.clockWhite : null,
                clockBlack: time ? time.clockBlack : null,
                isCrowned: move.isCrowned
            }
            for (let i = 0; i<move.capturedSquares.length; i++) {
                const sq = move.capturedSquares[i];
                positionData.move.captured.push(sq.number);
            }
        }
    }
    return positionData;
}

Game.prototype.parseTime = function(comment) {
    let arr = /\[%clock\s[w|W](\S+)\s[b|B](\S+)\]/.exec(comment);
    let res = null;
    if (arr !== null) {
         res = {clockWhite: arr[1], clockBlack: arr[2]};
    }
    return res;
}

Game.prototype._getStatusPrevIndex = function() {
    let status = true;
    if (this.index > 0) {
        let m = this.moves[this.index - 1];
        status = m.status;
    }
    return status;
};

Game.prototype.hasNext = function() {
    return this._getStatusNextIndex() && this.index < this._getLastIndex();
};

Game.prototype.hasPrev = function() {
    return this._getStatusPrevIndex() && this.index > -1;
};

Game.prototype.getCurrentMove = function() {
    let m = null;
    if (this.index > -1){
        m = this.moves[this.index];
    }
    return m;
};

Game.prototype.getNextMove = function() {
    let m = null;
    if (this.hasNext()) {
        m = this.moves[this.index + 1];
    }
    return m;
};

Game.prototype.getPrevMove = function() {
    let m = null;
    if (this.hasPrev()) {
        m = this.moves[this.index - 1];
    }
    return m;
};

Game.prototype.next = function() {
    let isOk = this.hasNext();
    if (isOk) {
        this.index++;
        let m = this.moves[this.index];
        if (m.status) {
            this.board.applyMove(m);
        } else {
            this.index--;
        }
    }
    return isOk;
};

Game.prototype.prev = function() {
    let isOk = this.hasPrev();
    if (isOk) {
        let m = this.moves[this.index];
        if (m.status) {
            this.board.applyMoveRev(m);
            this.index--;
        }
    }
    return isOk;
}

Game.prototype.start = function() {
    this._setIndex(-1);
    return this;
};

Game.prototype.end = function() {
    this._setIndex(this._getLastIndex());
    return this;
};

/** Position initiale = 0 ; Premier coup = 1. */
Game.prototype.setCursor = function(position) {
    this._setIndex(position - 1);
    return this;
};

/** Position initiale = -1 ; premier coup = 0 */
Game.prototype._setIndex = function(idx) {
    idx = this._constrainIndex(idx);

    let isOk = true;
    if (this.index < idx) {
        while (isOk && (this.index < idx)) {
            isOk = this.next();
        }
    } else if (this.index > idx) {
        while (isOk && (this.index > idx)) {
            isOk = this.prev();
        }
    }
    return this;
};

Game.prototype._getLastIndex = function() {
    return this.moves.length - 1;
};

Game.prototype._constrainIndex = function(idx) {
    if (idx < 0) {
        idx = -1;
    } else if (idx > this._getLastIndex()) {
        idx = this._getLastIndex();
    }

    return idx;
};

Game.prototype._hasError = function() {
    let err = false;
    for (let k = 0; k < this.moves.length; k++) {
        let m = this.moves[k];
        if (!m.status) {
            err = true;
            break;
        }
    }
    return err;
};


// [{'number':1,
//   'white':{'move':'32x26', 'current':false},
//   'black':{'move':'32x26', 'current':false}}]
Game.prototype.getNotation = function(){
    let list = [];

    if (this.moves.length > 0){

        // is first move a black move ?
        let m = this.moves[0];
        let notation = m.getNotation(this.isChessNotation);
        let shift = 0;
        if (m.color === Color.BLACK){
            let mapb = {};
            mapb['position'] = 1;
            mapb['move'] = notation;
            mapb['current'] = (0 === this.index);

            let map = {};
            map['black'] = mapb;
            map['number'] = 1;
            list.push(map);
            shift = 1;
        }

        let map = null;
        for (let k = 0 + shift; k < this.moves.length; k++) {
            let m = this.moves[k];
            let notation = m.getNotation(this.isChessNotation);
            let cpt = ~~((k + shift)/2) + 1; // 1, 1, 2, 2, 3, 3

            if (m.color === Color.WHITE){
                let mapw = {};
                mapw['position'] = k + 1;
                mapw['move'] = notation;
                mapw['current'] = (k === this.index);

                map = {};
                map['number'] = cpt;
                map['white'] = mapw;
            } else if (m.color === Color.BLACK){
                let mapb = {};
                mapb['position'] = k + 1;
                mapb['move'] = notation;
                mapb['current'] = (k === this.index);
                map['black'] = mapb;

                list.push(map);
                map = null; // see after loop
            }
        }

        // is last move a white move ?
        if (map !== null){
            list.push(map);
        }
    }

    return list;
}

Game.prototype.getCurrentFenPdnTag = function(pdn) {
    return '[FEN "'+this.getCurrentFen()+'"]';
}

Game.prototype.getCurrentFen = function(pdn) {
    let resultW = [];
    let resultB = [];
    const squares = this.board.squares;
    for (let i = 0; i < squares.length; i++) {
        const square = squares[i];
        if (square.piece === Piece.PAWN_WHITE) {
            const pr = resultW.length === 0 ? "W" : "";
            resultW.push(pr + square.number);
        } else if (square.piece === Piece.PAWN_BLACK) {
            const pr = resultB.length === 0 ? "B" : "";
            resultB.push(pr + square.number);
        } else if (square.piece === Piece.DAME_WHITE) {
            const pr = resultW.length === 0 ? "W" : "";
            resultW.push(pr + "K" + square.number);
        } else if (square.piece === Piece.DAME_BLACK) {
            const pr = resultB.length === 0 ? "B" : "";
            resultB.push(pr + "K" + square.number);
        }
    }

    let result = "W:";
    if (this._getLastMoveColor() === Color.WHITE) {
        result = "B:";
    }
    result += resultW.join(",") + ":" + resultB.join(",");
    return result;
}

Game.prototype.getPDNNotation = function(){
    let no = 1;
    let result = [];
    for (let i = 0; i < this.moves.length; i++) {
        const move = this.moves[i];
        if (move.color === Color.WHITE) {
            result.push(no++);
            result.push(".");
            result.push(move.getNotation(this.isChessNotation));
        } else if (move.color === Color.BLACK) {
            result.push(" ");
            result.push(move.getNotation(this.isChessNotation));
            result.push(" ");
        }
    }
    return result.join("");
}

Game.prototype.debug = function() {
    console.log("Etat courant de la partie :");

    let s = "";
    for (let k = 0; k < this.moves.length; k++) {
        let m = this.moves[k];
        if (k === this.index) {
            s += "[" + m.getNotation(this.isChessNotation) + "] ; ";
        } else {
            s += m.getNotation(this.isChessNotation) + " ; ";
        }
    }
    console.log(s);
    this.board.debugDraughtBoard();
    console.log("");
};

Game.prototype.debugFull = function() {
    this.start();
    this.debug();

    while (this.hasNext()) {
        this.next();
        this.debug();
    }
};

module.exports = Game;



// WEBPACK FOOTER //
// ./src/board/core/Game.js